<script setup>
import { ref, onMounted, computed } from "vue";
import Text from "@/v2/primitives/Text/Text.vue";
import ResponsiveImage from "@/components/Image/ResponsiveImage.vue";
import { RAS_MEDIA_SERVER_HOSTNAME } from "@/util/constants.ts";

const props = defineProps({
  imageUrl: {
    type: String,
    required: true,
  },
  caption: {
    type: String,
    default: "",
  },
});

const isImageLoaded = ref(false);

const actualImageUrl = computed(
  () => `https://${RAS_MEDIA_SERVER_HOSTNAME}/${props.imageUrl}/`
);

onMounted(() => {
  const img = new Image();
  img.src = actualImageUrl.value;

  img.onload = () => {
    isImageLoaded.value = true;
  };
});
</script>

<template>
  <div class="search-result-thumbnail">
    <Text
      v-if="!isImageLoaded"
      class="search-result-thumbnail--loading"
      variant="title4"
      >Loading...</Text
    >
    <ResponsiveImage
      v-show="isImageLoaded"
      class="search-result-thumbnail--image"
      :src="actualImageUrl"
      :alt="caption ?? 'Search result thumbnail'"
      sizes="350px"
    />
  </div>
</template>

<style scoped lang="scss">
.search-result-thumbnail {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-bottom: var(--spacing-base-lg);

  &--image {
    max-width: 100%;
    max-height: 100%;
    border: 8px solid var(--visual-dark-border);
    border-radius: var(--border-radius-large);
  }

  &--loading {
    color: var(--colors-surface-light-500);
  }
}
</style>
